import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FmsSynchronizationStatusApiResponse } from '@app/shared/fms-sync/models/fms-sync.api-models';
import { signalStoreCustomerRequestOptions } from '@app/shared/interceptors/signal-store-customer-context';
import { ArableAdviceService } from '@app/shared/services/arable-advice.service';

@Injectable({ providedIn: 'root' })
export class FmsSyncService extends ArableAdviceService {
  private readonly controllerEndpoint = `${this.baseUrl}/fms-sync`;

  triggerSync(customerId?: number): Observable<void> {
    return this.http.post<void>(
      `${this.controllerEndpoint}/trigger`,
      null,
      signalStoreCustomerRequestOptions(customerId),
    );
  }

  getSynchronizationStatus(customerId?: number): Observable<FmsSynchronizationStatusApiResponse> {
    return this.http.get<FmsSynchronizationStatusApiResponse>(
      `${this.controllerEndpoint}/status`,
      signalStoreCustomerRequestOptions(customerId),
    );
  }
}
